import { render, staticRenderFns } from "./v-navbar-search.vue?vue&type=template&id=01345500&"
import script from "./v-navbar-search.vue?vue&type=script&lang=js&"
export * from "./v-navbar-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports